export default __webpack_public_path__ + "static/media/bye.637777c0.svg";